export default __webpack_public_path__ + "static/media/phone-contact.e3b81c4e.svg";